import { compact, last } from "lodash";
import { useMemo } from "react";
import { GetAskAiChatSessionQueryQuery } from "types/graphql-schema";

import { assertEdgesNonNullWithStringId } from "@helpers/helpers";

const AskAIFollowUps = ({
  chatSession,
  onClickPromptSuggestion,
}: {
  chatSession: GetAskAiChatSessionQueryQuery["chatSession"];
  onClickPromptSuggestion: (suggestion: string) => void;
}) => {
  const messages = useMemo(() => {
    return chatSession?.messages
      ? assertEdgesNonNullWithStringId(chatSession?.messages)
      : [];
  }, [chatSession]);

  const lastMessage = useMemo(() => {
    return last(messages);
  }, [messages]);

  const lastMessageIsFromAssistant = useMemo(() => {
    return lastMessage?.role === "assistant";
  }, [lastMessage]);

  const suggestions = useMemo(() => {
    return compact(chatSession?.suggestions || []);
  }, [chatSession]);

  const hasSuggestions = useMemo(
    () =>
      waffle.flag_is_active("ask-ai-follow-ups") &&
      lastMessage &&
      !lastMessage.isStreaming &&
      lastMessageIsFromAssistant &&
      suggestions &&
      suggestions.length > 0,
    [lastMessage, lastMessageIsFromAssistant, suggestions]
  );

  if (!hasSuggestions) {
    return null;
  }
  return (
    <div className="flex gap-1.5 items-center overflow-x-auto scrollbar-hidden flex-nowrap">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          onClick={() => onClickPromptSuggestion(suggestion)}
          className="bg-gray-50 px-3 py-2 rounded-md text-gray-600 hover:bg-gray-100 text-nowrap"
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default AskAIFollowUps;
